export const manhwaList = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / 张成乐',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20solo%20leveling%20hunter%20with%20dark%20aura%20purple%20energy%2C%20clean%20background%20with%20gradient%2C%20modern%20anime%20illustration%2C%20sharp%20lineart%2C%20dramatic%20lighting%2C%20professional%20webtoon%20cover%20style%20with%20simple%20dark%20backdrop&width=600&height=800&seq=manhwa-cover-01&orientation=portrait',
    description: '十年前，世界与世界之间的"门"被打开，魔物不断涌出，而部分人类觉醒了特殊能力与之对抗，这种能力者被称为"猎人"。实力最弱的E级猎人成振宇，在某次任务中遭遇双重地下城的生死危机后，意外获得了"系统"的力量，成为了唯一能够"升级"的猎人。从此，他从最弱一步步走向最强。',
    status: '连载中',
    chapters: 200,
    rating: 9.7,
    views: 15200000,
    tags: ['热血', '系统', '升级流', '战斗'],
    updatedAt: '2026-07-08',
    featured: true,
    trending: 1,
  },
  {
    id: 2,
    title: '神之塔',
    author: 'SIU',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20tower%20of%20god%20fantasy%20style%2C%20mysterious%20tower%20reaching%20sky%2C%20boy%20climbing%2C%20golden%20and%20blue%20mystical%20atmosphere%2C%20clean%20simple%20background%2C%20anime%20illustration%20style%2C%20epic%20fantasy%20vibe&width=600&height=800&seq=manhwa-cover-02&orientation=portrait',
    description: '住在塔外的少年夜，为了追随唯一的朋友——少女蕾哈尔而进入神之塔。塔的每一层都有一个测试，只有通过测试才能继续向上攀登。夜在塔中遇到了各种伙伴和敌人，逐渐揭开了塔的神秘面纱和自己身世的秘密。',
    status: '连载中',
    chapters: 580,
    rating: 9.5,
    views: 12800000,
    tags: ['奇幻', '冒险', '友情', '世界观宏大'],
    updatedAt: '2026-07-07',
    featured: true,
    trending: 2,
  },
  {
    id: 3,
    title: '女神降临',
    author: '喵喵',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20true%20beauty%20style%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20soft%20pink%20and%20peach%20tones%2C%20clean%20simple%20background%2C%20romantic%20anime%20illustration%2C%20elegant%20feminine%20vibe&width=600&height=800&seq=manhwa-cover-03&orientation=portrait',
    description: '因为长相平凡而一直遭受欺凌的女高中生任朱静，通过化妆技巧彻底改变了自己的外貌，成为了校园里的"女神"。然而她一直活在素颜被发现的恐惧中。直到遇见了知道她素颜却依然喜欢她的修豪，和总是默默守护她的瑞俊……',
    status: '已完结',
    chapters: 250,
    rating: 9.3,
    views: 18500000,
    tags: ['恋爱', '校园', '化妆', '青春'],
    updatedAt: '2026-06-30',
    featured: true,
    trending: 3,
  },
  {
    id: 4,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20omniscient%20reader%20viewpoint%20style%2C%20man%20reading%20book%20with%20glowing%20pages%2C%20apocalyptic%20background%20subtle%2C%20blue%20and%20white%20mystical%20tone%2C%20clean%20modern%20anime%20illustration&width=600&height=800&seq=manhwa-cover-04&orientation=portrait',
    description: '平凡的上班族金独子，十年来唯一的乐趣就是追读网络小说《在灭亡的世界中存活的三种方法》。当小说完结的那一天，小说中的世界突然变成了现实。作为唯一的读者，金独子知道这个世界的所有秘密和未来走向，他必须利用这些知识在这个末日世界中生存下去。',
    status: '连载中',
    chapters: 210,
    rating: 9.8,
    views: 14000000,
    tags: ['末世', '系统', '智斗', '生存'],
    updatedAt: '2026-07-07',
    featured: true,
    trending: 4,
  },
  {
    id: 5,
    title: '外貌至上主义',
    author: '朴泰俊',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20lookism%20style%2C%20boy%20with%20dual%20identity%20split%20face%2C%20handsome%20and%20ugly%20contrast%2C%20dark%20street%20background%2C%20gritty%20anime%20illustration%2C%20high%20contrast%20lighting&width=600&height=800&seq=manhwa-cover-05&orientation=portrait',
    description: '胖墩墩、长相平平的男高中生朴亨硕，因为在学校长期遭受霸凌而转学到了首尔。某天醒来，他发现自己拥有了一个完美的身体——高大帅气、身材健硕。从此他的生活天翻地覆，白天用完美的身体生活，晚上则回到原本的身体中。',
    status: '连载中',
    chapters: 470,
    rating: 9.4,
    views: 16500000,
    tags: ['校园', '成长', '热血', '社会议题'],
    updatedAt: '2026-07-06',
    featured: false,
    trending: 5,
  },
  {
    id: 6,
    title: '看脸时代',
    author: '朴泰俊',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20lookism%20sequel%20style%2C%20handsome%20man%20in%20school%20uniform%2C%20urban%20street%20background%20subtle%2C%20warm%20orange%20and%20brown%20tones%2C%20anime%20illustration%2C%20clean%20professional%20style&width=600&height=800&seq=manhwa-cover-06&orientation=portrait',
    description: '朴亨硕在拥有了完美的第二身体后，开始深入了解首尔江南区的校园生态。他逐渐发现了外貌对人际关系和社会地位的巨大影响。在这个"看脸"的时代里，他用双重身份体验着截然不同的人生，也在经历中不断成长。',
    status: '连载中',
    chapters: 320,
    rating: 9.2,
    views: 11200000,
    tags: ['校园', '社会', '成长', '热血'],
    updatedAt: '2026-07-05',
    featured: false,
    trending: 6,
  },
  {
    id: 7,
    title: '甜蜜的谎言',
    author: '金善熙',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20sweet%20lies%20style%2C%20couple%20holding%20hands%20cherry%20blossom%2C%20soft%20pink%20pastel%20background%2C%20romantic%20anime%20illustration%2C%20gentle%20warm%20lighting%2C%20dreamy%20atmosphere&width=600&height=800&seq=manhwa-cover-07&orientation=portrait',
    description: '平凡的上班族韩素利，为了应付家人的催婚，谎称自己已经有了男朋友。没想到家人突然要来首尔看她，她必须在三天内找到一个"假男友"。机缘巧合之下，公司的冷面上司姜道贤答应了她的请求……一场始于谎言的甜蜜恋爱就此展开。',
    status: '已完结',
    chapters: 120,
    rating: 9.0,
    views: 8900000,
    tags: ['恋爱', '职场', '契约恋爱', '甜宠'],
    updatedAt: '2026-06-25',
    featured: false,
    trending: 7,
  },
  {
    id: 8,
    title: '大贵族',
    author: '孙齐皓 / 李光洙',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20noblesse%20vampire%20style%2C%20elegant%20noble%20vampire%20with%20silver%20hair%2C%20gothic%20castle%20subtle%20background%2C%20red%20and%20black%20color%20scheme%2C%20dark%20anime%20illustration%2C%20aristocratic%20vibe&width=600&height=800&seq=manhwa-cover-08&orientation=portrait',
    description: '拥有强大力量的贵族——卡迪斯·艾特拉马·迪·莱杰罗，在沉睡了820年后在现代韩国苏醒。他进入一所高中，试图过上平静的生活。然而他的存在引来了各种势力的觊觎。为了守护身边的人，他不得不再次使用自己的力量。',
    status: '已完结',
    chapters: 544,
    rating: 9.5,
    views: 13500000,
    tags: ['吸血鬼', '贵族', '战斗', '友情'],
    updatedAt: '2026-05-20',
    featured: true,
    trending: 8,
  },
  {
    id: 9,
    title: '鬼怪的复仇',
    author: '韩智勋',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20revenge%20style%2C%20mysterious%20figure%20in%20shadow%2C%20dark%20alley%20background%2C%20cold%20blue%20and%20gray%20tones%2C%20suspenseful%20anime%20illustration%2C%20murder%20mystery%20atmosphere&width=600&height=800&seq=manhwa-cover-09&orientation=portrait',
    description: '十年前，一场离奇的车祸夺走了李贤宇全家人的性命。所有人都认为那只是一场意外，但贤宇知道，那是谋杀。十年后，他以全新的身份回到韩国，精心策划了一场复仇大戏。每一个加害者都将为自己的罪行付出代价。',
    status: '连载中',
    chapters: 85,
    rating: 9.4,
    views: 7200000,
    tags: ['悬疑', '复仇', '犯罪', '心理'],
    updatedAt: '2026-07-06',
    featured: false,
    trending: 9,
  },
  {
    id: 10,
    title: '搞笑一家人',
    author: '李熙明',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20family%20style%2C%20happy%20family%20laughing%20together%2C%20bright%20yellow%20and%20green%20colors%2C%20warm%20home%20background%2C%20funny%20anime%20illustration%2C%20heartwarming%20slice%20of%20life&width=600&height=800&seq=manhwa-cover-10&orientation=portrait',
    description: '讲述了一个普通韩国家庭的爆笑日常。有一个爱唠叨的妈妈、一个老实巴交的爸爸、一个调皮捣蛋的儿子和一个古灵精怪的女儿。每天都有各种啼笑皆非的事情在这个家庭中上演，让人捧腹大笑的同时又感到温暖。',
    status: '连载中',
    chapters: 310,
    rating: 9.1,
    views: 9600000,
    tags: ['搞笑', '日常', '家庭', '治愈'],
    updatedAt: '2026-07-04',
    featured: false,
    trending: 10,
  },
  {
    id: 11,
    title: '剑尊归来',
    author: '柳城',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20webtoon%20cover%20sword%20master%20return%20style%2C%20swordsman%20with%20flowing%20robes%2C%20mountain%20peak%20background%2C%20golden%20and%20green%20oriental%20tones%2C%20wuxia%20anime%20illustration%2C%20epic%20heroic%20atmosphere&width=600&height=800&seq=manhwa-cover-11&orientation=portrait',
    description: '一代剑尊赵杰，在击败魔教教主后力竭而死。当他再次睁开眼时，发现自己回到了二十年前的少年时代。带着前世的记忆和剑术，他决定弥补所有的遗憾，守护那些曾经失去的人，并在这个时代再次登顶武林之巅。',
    status: '连载中',
    chapters: 165,
    rating: 9.6,
    views: 11300000,
    tags: ['武侠', '重生', '复仇', '强者回归'],
    updatedAt: '2026-07-08',
    featured: true,
    trending: 11,
  },
  {
    id: 12,
    title: '她的私生活',
    author: '金成妍',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20her%20private%20life%20style%2C%20professional%20woman%20in%20office%20attire%2C%20art%20gallery%20background%2C%20elegant%20beige%20and%20rose%20tones%2C%20sophisticated%20anime%20illustration%2C%20refined%20romantic%20vibe&width=600&height=800&seq=manhwa-cover-12&orientation=portrait',
    description: '成德美是美术馆的首席策展人，在外人眼中是完美的职场女性。但她有一个不为人知的秘密——她是一个狂热的偶像追星族。为了隐藏这个秘密她费尽心思，直到新来的馆长莱恩·金发现了她的秘密，两人之间展开了一段有趣的办公室恋情。',
    status: '已完结',
    chapters: 98,
    rating: 9.0,
    views: 7800000,
    tags: ['恋爱', '职场', '追星', '浪漫喜剧'],
    updatedAt: '2026-06-15',
    featured: false,
    trending: 12,
  },
  {
    id: 13,
    title: '丧尸校园',
    author: '朱东根',
    category: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20horror%20webtoon%20cover%20zombie%20school%20style%2C%20students%20trapped%20in%20classroom%2C%20dark%20corridor%20background%2C%20green%20and%20black%20eerie%20tones%2C%20survival%20horror%20anime%20illustration%2C%20tense%20apocalyptic%20atmosphere&width=600&height=800&seq=manhwa-cover-13&orientation=portrait',
    description: '孝山高中突然爆发了丧尸病毒，被感染的学生和老师变成了嗜血的怪物。一群被困在校园里的学生必须依靠彼此的力量生存下去。在生与死的考验面前，人性的善与恶都被无限放大。',
    status: '已完结',
    chapters: 130,
    rating: 9.3,
    views: 14200000,
    tags: ['丧尸', '生存', '校园', '人性'],
    updatedAt: '2026-05-10',
    featured: false,
    trending: 13,
  },
  {
    id: 14,
    title: '民国奇探',
    author: '李恩',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20cover%20detective%20style%2C%20man%20in%20vintage%20suit%20with%20magnifying%20glass%2C%201920s%20Shanghai%20street%20background%2C%20sepia%20and%20brown%20tones%2C%20mystery%20anime%20illustration%2C%20noir%20atmosphere&width=600&height=800&seq=manhwa-cover-14&orientation=portrait',
    description: '1920年代的上海租界，一位来自朝鲜的年轻侦探凭借过人的推理能力屡破奇案。在这个中西文化交融、各方势力盘踞的年代，他用智慧和勇气揭开了一个个惊天谜团。',
    status: '连载中',
    chapters: 56,
    rating: 9.1,
    views: 4100000,
    tags: ['古风', '推理', '民国', '悬疑'],
    updatedAt: '2026-07-05',
    featured: false,
    trending: 14,
  },
  {
    id: 15,
    title: '我的ID是江南美人',
    author: '淇萌琪',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20gangnam%20beauty%20style%2C%20pretty%20girl%20in%20university%20campus%2C%20cherry%20blossom%20trees%20background%2C%20soft%20pastel%20pink%20and%20white%2C%20youth%20anime%20illustration%2C%20fresh%20spring%20vibe&width=600&height=800&seq=manhwa-cover-15&orientation=portrait',
    description: '从小因为长相而自卑的姜美来，在高考后做了整形手术，变成了人人称赞的"江南美人"。进入大学后她以为可以开始崭新的人生，却发现自己依然无法摆脱对外貌的执念。而在校园里，她遇到了一个能透过外表看到她内心的人——都炅锡。',
    status: '已完结',
    chapters: 80,
    rating: 9.2,
    views: 10200000,
    tags: ['校园', '成长', '外貌', '爱情'],
    updatedAt: '2026-06-01',
    featured: false,
    trending: 15,
  },
  {
    id: 16,
    title: '活着',
    author: '金作家',
    category: 'daily',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20webtoon%20cover%20daily%20life%20style%2C%20young%20man%20drinking%20coffee%20at%20cafe%20window%2C%20urban%20cityscape%20background%2C%20warm%20brown%20and%20cream%20tones%2C%20relaxed%20anime%20illustration%2C%20cozy%20everyday%20atmosphere&width=600&height=800&seq=manhwa-cover-16&orientation=portrait',
    description: '这是一部关于平凡人日常生活的治愈漫画。27岁的自由职业者金在民，没有固定的工作，没有恋爱对象，却依然努力地活着。每一天都看似平淡无奇，但在细微之处，却充满了生活的温度和小确幸。让你在疲惫的日常中找到继续前行的力量。',
    status: '连载中',
    chapters: 145,
    rating: 9.0,
    views: 5600000,
    tags: ['日常', '治愈', '生活', '温暖'],
    updatedAt: '2026-07-03',
    featured: false,
    trending: 16,
  },
  {
    id: 17,
    title: '重生之都市修仙',
    author: '十里剑神',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20cultivation%20webtoon%20cover%20urban%20immortal%20style%2C%20man%20with%20spiritual%20energy%20in%20modern%20city%2C%20neon%20cityscape%20background%2C%20purple%20and%20gold%20mystical%20tones%2C%20fantasy%20anime%20illustration%2C%20supernatural%20modern%20vibe&width=600&height=800&seq=manhwa-cover-17&orientation=portrait',
    description: '修仙界第一强者陈凡，在渡劫失败后重生回到了地球的少年时代。前世的他是人人可欺的废物，今生的他却是俯瞰众生的仙尊。在这个灵气稀薄的现代都市中，他重新踏上修仙之路，一步步走向巅峰。',
    status: '连载中',
    chapters: 340,
    rating: 9.5,
    views: 17800000,
    tags: ['修仙', '重生', '都市', '爽文'],
    updatedAt: '2026-07-08',
    featured: true,
    trending: 17,
  },
  {
    id: 18,
    title: '便利店新星',
    author: '活泼份子',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20convenience%20store%20style%2C%20quirky%20girl%20working%20at%20store%20counter%2C%20bright%20convenience%20store%20interior%2C%20colorful%20and%20vibrant%20tones%2C%20funny%20anime%20illustration%2C%20energetic%20chaotic%20vibe&width=600&height=800&seq=manhwa-cover-18&orientation=portrait',
    description: '崔大贤是一家24小时便利店的店长，生活按部就班。直到那个充满个性的丁新星来应聘夜班兼职，他平静的生活彻底被打乱了。这个看似不靠谱的女孩，却有着令人意想不到的魅力和故事。两人一起守护着小小的便利店，也守护着彼此的梦想。',
    status: '已完结',
    chapters: 68,
    rating: 8.9,
    views: 6500000,
    tags: ['搞笑', '日常', '职场', '治愈'],
    updatedAt: '2026-04-28',
    featured: false,
    trending: 18,
  },
  {
    id: 19,
    title: '诡秘之主',
    author: '会说话的肘子',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20webtoon%20cover%20occult%20style%2C%20mysterious%20figure%20in%20top%20hat%20and%20cloak%2C%20foggy%20Victorian%20street%20background%2C%20dark%20green%20and%20brass%20tones%2C%20steampunk%20anime%20illustration%2C%20arcane%20mysterious%20atmosphere&width=600&height=800&seq=manhwa-cover-19&orientation=portrait',
    description: '周明瑞穿越到了一个蒸汽与机械的奇幻世界，成为了一个普通的历史系大学生。但一次意外让他接触到了这个世界的超凡力量。在这个充满诡秘与危险的世界里，他一步步探索着隐藏在世界表象之下的真相。',
    status: '连载中',
    chapters: 290,
    rating: 9.7,
    views: 16800000,
    tags: ['悬疑', '奇幻', '克苏鲁', '智斗'],
    updatedAt: '2026-07-07',
    featured: true,
    trending: 19,
  },
  {
    id: 20,
    title: '某天成为公主',
    author: 'Spoon / Plutus',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20webtoon%20cover%20princess%20style%2C%20beautiful%20princess%20in%20elegant%20gown%2C%20royal%20palace%20garden%20background%2C%20soft%20golden%20and%20rose%20tones%2C%20fairy%20tale%20anime%20illustration%2C%20elegant%20storybook%20vibe&width=600&height=800&seq=manhwa-cover-20&orientation=portrait',
    description: '一觉醒来，我变成了小说中的公主——但是是在她即将被亲生父亲处死的那一天！为了在这个世界中活下去，我必须改变故事的走向。从讨好冷血的父皇开始，我踏上了改变命运的旅程。没想到，这个计划中的"工具人"父皇，却渐渐对我展现出了不同的一面……',
    status: '连载中',
    chapters: 185,
    rating: 9.4,
    views: 12500000,
    tags: ['穿越', '恋爱', '宫廷', '父女'],
    updatedAt: '2026-07-06',
    featured: false,
    trending: 20,
  },
];